import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const CookiesPolicy = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Typography variant="h3" component="h1" gutterBottom>
        Política de Cookies
      </Typography>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" gutterBottom>
          1. ¿Qué son las cookies?
        </Typography>
        <Typography paragraph>
          Las cookies son pequeños archivos de texto que se almacenan en su dispositivo cuando visita nuestro sitio web. Estas cookies nos ayudan a hacer que su experiencia de navegación sea mejor.
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" gutterBottom>
          2. Tipos de Cookies que Utilizamos
        </Typography>
        <ul className="list-disc pl-6 space-y-2">
          <li>
            <Typography variant="subtitle1" component="span" fontWeight="bold">
              Cookies Esenciales:
            </Typography>
            {' '}Necesarias para el funcionamiento básico del sitio
          </li>
          <li>
            <Typography variant="subtitle1" component="span" fontWeight="bold">
              Cookies de Rendimiento:
            </Typography>
            {' '}Para analizar cómo se utiliza nuestro sitio
          </li>
          <li>
            <Typography variant="subtitle1" component="span" fontWeight="bold">
              Cookies de Funcionalidad:
            </Typography>
            {' '}Para recordar sus preferencias
          </li>
        </ul>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" gutterBottom>
          3. Control de Cookies
        </Typography>
        <Typography paragraph>
          Puede controlar y/o eliminar las cookies según desee. Puede eliminar todas las cookies que ya están en su dispositivo y puede configurar la mayoría de los navegadores para evitar que se coloquen.
        </Typography>
      </Box>

      <Box>
        <Typography variant="h5" gutterBottom>
          4. Más Información
        </Typography>
        <Typography paragraph>
          Para obtener más información sobre cómo utilizamos las cookies, póngase en contacto con nosotros a través de nuestros canales de atención al cliente.
        </Typography>
      </Box>
    </Container>
  );
};

export default CookiesPolicy;